import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput, AbcdInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar, OverlayTrigger, Tooltip} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import store from "store2";

@connect((state, props) => {
	return {
		state: state.datagrids.get('client')
	};
})
class HeaderFilter extends Component {
	render() {
		return (
			<div style={{marginBottom: 10}}>
				<FilterField filter={this.props.filter} field="letter"/>
			</div>
		)
	}
}

export default class List extends Component {

	static contextTypes = {
		location: React.PropTypes.object
	};

	constructor(props, context) {
		super(props);

		const rendererLink = (val, row) => {
			return <a href={'/client/'+row.id} onClick={(e) => this.handleOpen(row, e)}>{val}</a>;
		};

    const rendererFiles = (val, row) => {
      const files = row.files.map(file => {
        const tooltip = <Tooltip id="file">{file.title}</Tooltip>
        return (
          <OverlayTrigger key={file.id} placement="top" overlay={tooltip}>
            <a style={{color: '#000'}} href={'/file/download/' + file.id}>
              <i style={{fontSize: 13}} className="glyphicon glyphicon-paperclip"/>
            </a>
          </OverlayTrigger>
        )
      });
      return <div>
        {files}
      </div>
    };

		this.columnModel = [
			{
				name: 'title',
				title: 'Název',
				field: 'title',
				renderer: rendererLink
			},
			{
				name: 'address',
				title: 'Adresa',
				field: 'street',
				viewport: 'tablet',
				renderer: (val, row) => {
					return row.street + ', ' + row.zip + ' ' + row.city;
				}
			},
			{
				name: 'email',
				title: 'E-mail',
				field: 'email',
				viewport: 'tablet',
        renderer: (val, row) => {
          const arr = [row.email]
          if (row.email2) {
            arr.push(row.email2);
          }
          return arr.join(', ');
        }
			},
			{
				name: 'phone',
				title: 'Telefon',
				field: 'phone',
				viewport: 'tablet'
			},
      {
        name: 'files',
        width: 58,
        title: <i style={{fontSize: 13}} className="glyphicon glyphicon-paperclip"/>,
        sortable: false,
        renderer: rendererFiles
      },
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				style: {whiteSpace: 'nowrap'},
				width: 30,
				align: 'center',
				sortable: false,
				renderer: (val, row) => {
					return (
						<a href={'/client/'+val} onClick={(e) => this.handleOpen(row, e)}>
							<i className="fa fa-pencil position-left"></i><span className="vp-desktop">Upravit</span>
						</a>
					);
				}
			}
		];

		const filterSchema = {
			id: { class: FilterInput },
			letter: { class: AbcdInput },
			title: { class: FilterInput },
			address: { class: FilterInput },
			zip: { class: FilterInput },
			city: { class: FilterInput },
			email: { class: FilterInput },
			phone: { class: FilterInput },
			notice: { class: FilterInput },
			fulltext: { class: SearchInput },
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
		const sessionState = store.session.get('dg-client');
		// default
		let filter = {};
		// session
		if (sessionState && sessionState.filter) {
			filter = sessionState.filter;
		}
		this.defaultFilter = filter;
		this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'title', 'direction': 'asc'};

	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('client.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('client.change', this.changeListener);
	}

	handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm('client', row.title, row);
	}

	handleAddFilter(key, value) {
		const values = this.filter.getValues();
		this.filter.setValues(values.set(key, immutable.fromJS(value)));
		this.props.datagridActions.setFilter('client', values.set(key, immutable.fromJS(value)));
	}

	handleNewClick(e) {
		e.preventDefault();
		this.props.newTab();
	}

	render() {

		const buttons = <Button href="/client/0" onClick={(e) => this.handleNewClick(e)}>
			<i className="fa fa-plus position-left"/>Nová firma
		</Button>;

		const header = <HeaderFilter filter={this.filter} />;

		return (
			<Datagrid
				ref="datagrid"
				id="client"
				api="client.getList"
				buttons={buttons}
				header={header}
				filters={['fulltext']}
				filter={this.filter}
				saveState={true}
				getRowClassName={null}
				columnModel={this.columnModel}
				defaultFilter={this.defaultFilter}
				forceFilter={this.filterUrl}
				defaultSort={this.defaultSort}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Client/List.js